export enum CmpConfigThemeToolbarField {
    ACTIVE = "active",
    POSITION = "position",
    SIZE = "size",
    STYLE = "style",
    OFFSET = "offset"
}
